import React, { useState, useEffect } from 'react';
import { googleReady } from './TranslateWidget';
import './CustomLanguageDropdown.css';

const LANGS = [
    { code: '', label: 'Select Language' },
    { code: 'af', label: 'Afrikaans' },
    { code: 'sq', label: 'Albanian' },
    { code: 'am', label: 'Amharic' },
    { code: 'ar', label: 'Arabic' },
    { code: 'hy', label: 'Armenian' },
    { code: 'as', label: 'Assamese' },
    { code: 'ay', label: 'Aymara' },
    { code: 'az', label: 'Azerbaijani' },
    { code: 'bm', label: 'Bambara' },
    { code: 'eu', label: 'Basque' },
    { code: 'be', label: 'Belarusian' },
    { code: 'bn', label: 'Bengali' },
    { code: 'bho', label: 'Bhojpuri' },
    { code: 'bs', label: 'Bosnian' },
    { code: 'bg', label: 'Bulgarian' },
    { code: 'ca', label: 'Catalan' },
    { code: 'ceb', label: 'Cebuano' },
    { code: 'zh-CN', label: 'Chinese (Simplified)' },
    { code: 'zh-TW', label: 'Chinese (Traditional)' },
    { code: 'co', label: 'Corsican' },
    { code: 'hr', label: 'Croatian' },
    { code: 'cs', label: 'Czech' },
    { code: 'da', label: 'Danish' },
    { code: 'dv', label: 'Dhivehi' },
    { code: 'doi', label: 'Dogri' },
    { code: 'nl', label: 'Dutch' },
    { code: 'en', label: 'English' },
    { code: 'eo', label: 'Esperanto' },
    { code: 'et', label: 'Estonian' },
    { code: 'ee', label: 'Ewe' },
    { code: 'tl', label: 'Filipino' },
    { code: 'fi', label: 'Finnish' },
    { code: 'fr', label: 'French' },
    { code: 'fy', label: 'Frisian' },
    { code: 'gl', label: 'Galician' },
    { code: 'ka', label: 'Georgian' },
    { code: 'de', label: 'German' },
    { code: 'el', label: 'Greek' },
    { code: 'gn', label: 'Guarani' },
    { code: 'gu', label: 'Gujarati' },
    { code: 'ht', label: 'Haitian Creole' },
    { code: 'ha', label: 'Hausa' },
    { code: 'haw', label: 'Hawaiian' },
    { code: 'he', label: 'Hebrew' },
    { code: 'hi', label: 'Hindi' },
    { code: 'hmn', label: 'Hmong' },
    { code: 'hu', label: 'Hungarian' },
    { code: 'is', label: 'Icelandic' },
    { code: 'ig', label: 'Igbo' },
    { code: 'ilo', label: 'Ilocano' },
    { code: 'id', label: 'Indonesian' },
    { code: 'ga', label: 'Irish' },
    { code: 'it', label: 'Italian' },
    { code: 'ja', label: 'Japanese' },
    { code: 'jv', label: 'Javanese' },
    { code: 'kn', label: 'Kannada' },
    { code: 'kk', label: 'Kazakh' },
    { code: 'km', label: 'Khmer' },
    { code: 'rw', label: 'Kinyarwanda' },
    { code: 'gom', label: 'Konkani' },
    { code: 'ko', label: 'Korean' },
    { code: 'ku', label: 'Kurdish (Kurmanji)' },
    { code: 'ky', label: 'Kyrgyz' },
    { code: 'lo', label: 'Lao' },
    { code: 'la', label: 'Latin' },
    { code: 'lv', label: 'Latvian' },
    { code: 'ln', label: 'Lingala' },
    { code: 'lt', label: 'Lithuanian' },
    { code: 'lg', label: 'Luganda' },
    { code: 'lb', label: 'Luxembourgish' },
    { code: 'mk', label: 'Macedonian' },
    { code: 'mai', label: 'Maithili' },
    { code: 'mg', label: 'Malagasy' },
    { code: 'ms', label: 'Malay' },
    { code: 'ml', label: 'Malayalam' },
    { code: 'mt', label: 'Maltese' },
    { code: 'mi', label: 'Maori' },
    { code: 'mr', label: 'Marathi' },
    { code: 'mni-Mtei', label: 'Meiteilon (Manipuri)' },
    { code: 'lus', label: 'Mizo' },
    { code: 'mn', label: 'Mongolian' },
    { code: 'my', label: 'Myanmar (Burmese)' },
    { code: 'ne', label: 'Nepali' },
    { code: 'no', label: 'Norwegian' },
    { code: 'ny', label: 'Nyanja (Chichewa)' },
    { code: 'or', label: 'Odia (Oriya)' },
    { code: 'om', label: 'Oromo' },
    { code: 'ps', label: 'Pashto' },
    { code: 'fa', label: 'Persian' },
    { code: 'pl', label: 'Polish' },
    { code: 'pt', label: 'Portuguese' },
    { code: 'pa', label: 'Punjabi' },
    { code: 'qu', label: 'Quechua' },
    { code: 'ro', label: 'Romanian' },
    { code: 'ru', label: 'Russian' },
    { code: 'sm', label: 'Samoan' },
    { code: 'sa', label: 'Sanskrit' },
    { code: 'gd', label: 'Scots Gaelic' },
    { code: 'nso', label: 'Sepedi' },
    { code: 'sr', label: 'Serbian' },
    { code: 'st', label: 'Sesotho' },
    { code: 'sn', label: 'Shona' },
    { code: 'sd', label: 'Sindhi' },
    { code: 'si', label: 'Sinhala' },
    { code: 'sk', label: 'Slovak' },
    { code: 'sl', label: 'Slovenian' },
    { code: 'so', label: 'Somali' },
    { code: 'es', label: 'Spanish' },
    { code: 'su', label: 'Sundanese' },
    { code: 'sw', label: 'Swahili' },
    { code: 'sv', label: 'Swedish' },
    { code: 'tg', label: 'Tajik' },
    { code: 'ta', label: 'Tamil' },
    { code: 'tt', label: 'Tatar' },
    { code: 'te', label: 'Telugu' },
    { code: 'th', label: 'Thai' },
    { code: 'ti', label: 'Tigrinya' },
    { code: 'ts', label: 'Tsonga' },
    { code: 'tr', label: 'Turkish' },
    { code: 'tk', label: 'Turkmen' },
    { code: 'ak', label: 'Twi (Akan)' },
    { code: 'uk', label: 'Ukrainian' },
    { code: 'ur', label: 'Urdu' },
    { code: 'ug', label: 'Uyghur' },
    { code: 'uz', label: 'Uzbek' },
    { code: 'vi', label: 'Vietnamese' },
    { code: 'cy', label: 'Welsh' },
    { code: 'xh', label: 'Xhosa' },
    { code: 'yi', label: 'Yiddish' },
    { code: 'yo', label: 'Yoruba' },
    { code: 'zu', label: 'Zulu' }
];

const CustomLanguageDropdown = () => {
    const [value, setValue] = useState('');

    useEffect(() => {
        const esc = (e) => e.key === 'Escape' && setValue('');
        window.addEventListener('keydown', esc);
        return () => window.removeEventListener('keydown', esc);
    }, []);

    const handleChange = (e) => {
        const lang = e.target.value;
        setValue(lang);
        if (!lang) return;

        const sendToGoogle = () => {
            const combo = document.querySelector('.goog-te-combo');
            if (combo) {
                combo.value = lang;
                combo.dispatchEvent(new Event('change'));
                return true;
            }
            return false;
        };

        if (googleReady.current && sendToGoogle()) return;

        let tries = 0;
        const id = setInterval(() => {
            if (sendToGoogle() || ++tries > 10) clearInterval(id);
        }, 200);

        setTimeout(() => {
            if (!googleReady.current) {
                const u = encodeURIComponent(window.location.href);
                window.location.href = `https://translate.google.com/translate?hl=${lang}&sl=en&u=${u}`;
            }
        }, 2200);
    };

    return (
        <select
            className="custom-lang-select"
            value={value}
            onChange={handleChange}
        >
            {LANGS.map(({ code, label }) => (
                <option key={code} value={code}>
                    {label}
                </option>
            ))}
        </select>
    );
};

export default CustomLanguageDropdown;
